import { useApp } from '@/hooks/use-app-context';
import { cn } from '@/lib/utils';
import type { ComplaintType } from './complaints.types';

const TYPES: ComplaintType[] = ['bug', 'suggestion', 'other'];

interface ComplaintsTypeSelectorProps {
  value: ComplaintType;
  onChange: (type: ComplaintType) => void;
}

const labelKey: Record<ComplaintType, string> = {
  bug: 'complaintsBug',
  suggestion: 'complaintsSuggestion',
  other: 'complaintsOther',
};

export function ComplaintsTypeSelector({ value, onChange }: ComplaintsTypeSelectorProps) {
  const { t } = useApp();

  return (
    <div className="relative grid h-11 grid-cols-3 rounded-2xl border border-border/40 bg-background/60 p-1">
      <span
        className={cn(
          'absolute bottom-1 left-1 top-1 w-[calc(33.333%-0.25rem)] rounded-[0.85rem] border border-border/40 bg-muted/30 transition-transform duration-300 ease-out',
          value === 'suggestion' && 'translate-x-full',
          value === 'other' && 'translate-x-[calc(200%+0.5rem)]',
        )}
      />
      {TYPES.map((type) => (
        <button
          key={type}
          type="button"
          onClick={() => onChange(type)}
          className={cn(
            'relative z-10 rounded-xl px-3 text-xs font-semibold transition-colors',
            value === type ? 'text-primary' : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {t[labelKey[type]]}
        </button>
      ))}
    </div>
  );
}
